import React  from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CarouselDesktop from "../../../Commons/slider.jsx";
import defaultPackage from "../../../../../assets/images/defaultPackage.jpg";
import useMemeberInfo from "../../../../../dataHook/useMemeberInfoHook";
import useFeaturedListings from "../../../../../dataHook/useCommonHook";
import useWebsiteModules from "../../../../../dataHook/useAccessModules.js";
import {handleBadImgUrl, thumborImageUrl } from "../../../../../Utility.js";
import useDeviceView from "../../../../../dataHook/useDeviceView.js";
const useStyles = makeStyles((theme) => ({
  sectionContainer: {
   padding: theme.spacingRules.cardPaddingDesktop,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacingRules.cardPaddingMobile,
    },
  },
  sectionTitle: {
    fontSize: "42px",
    fontWeight: 700,
    color: theme.agentTheme.background.secondary_text,
    textAlign: "center",
    marginBottom: "50px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "32px",
      marginBottom: "40px",
    },
  },
  hotelCard: {
    padding:"1rem",
    position: "relative",
    maxWidth: "280px",
    width: "100%",
    borderRadius: "16px",
    backgroundColor: "transparent",
    overflow: "hidden",
    transition: "all 0.3s ease",
  },
  cardMedia: {
    height: "360px",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
  },
  hotelImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "16px",
  },
  cardContent: {
    padding: "8px 0",
  },
  hotelName: {
    fontSize: "16px",
    fontWeight: 700,
    color: theme.agentTheme.background.primary_text,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const FeaturedHotelCard = ({ destination, username, classes }) => {
  return (
    <Card className={classes.hotelCard} elevation={0}>
      <Box
        className={classes.cardMedia}
        onClick={() =>
          window.location.href = username
            ? `/${username}/packages?&destination=${destination?.name}&isDestinationPage=true`
            : `/packages?&destination=${destination?.name}&isDestinationPage=true`
        }
      >
        <img
          src={
            thumborImageUrl(
              handleBadImgUrl(destination?.destination_detail?.image),
              600,
              400
            ) || defaultPackage
          }
          alt={destination?.name}
          className={classes.hotelImage}
        />
      </Box>

      <CardContent className={classes.cardContent}>
        <Typography className={classes.hotelName}>
          {destination?.name || ""}
        </Typography>
      </CardContent>
    </Card>
  );
};

const FeaturedHotels = () => {
  const {isMobile} = useDeviceView();
  const {destinations = true} = useWebsiteModules();
  const classes = useStyles();
 const destination = useFeaturedListings('destinations',12);
   const {username = null} = useMemeberInfo();

  if (!destination || destination.length === 0 || !destinations)
    return null;

  const styleObj = {
    fontSize: isMobile ? "25px" : "35px",
    fontWeight: 700,
    textAlign: isMobile ? "center" : "left",
    linebreak: isMobile ? 3 : 2,
  };

  return (
    <Box className={classes.sectionContainer}>
      <Container>
        <CarouselDesktop
          shiftBy={1}
          getTestimonialItem={(item) => (
            <FeaturedHotelCard
              destination={item}
              username={username}
              classes={classes}
            />
          )}
          items={destination}
          showArrowParadise={false}
          itemsPerCarousel={isMobile ? 1 : 4}
          itemWidthPx={'100%'}
          toorThemeStepper={true}
          envytheme={true}
          styleObj={styleObj}
          title="Connect With Other Travellers"
          text="These popular destinations have a lot to offer"
        />
      </Container>
    </Box>
  );
};

export default FeaturedHotels;
